import React from "react";
import { Typography, Container } from "@mui/material";

const PageNotFound = () => {
  return (
    <Container sx={{ textAlign: "center", py: 8 }}>
      <Typography variant="h3" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1">
        Sorry, the page you are looking for does not exist.
      </Typography>
    </Container>
  );
};

export default PageNotFound;
